/* tslint:disable:jsx-no-lambda no-empty*/
import { LoadingIndicator, MUIButton, Notification } from '@abb/arcadia-ui-react';
import { Search } from '@module/shared';
import { defaultSite, IPagingSettings, ISiteModel, ISortingSettings } from '@module/shared/components/Site/models';
import { SERVIS_SEARCH_PLACEHOLDER } from '@service/constants';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '@module/shared/routerCompat';
import * as ActionCreators from '../actionCreators/registerSiteActionCreators';
import Sites from './Sites';

export class RegisterSitesContainer extends React.Component<any, any> {
  public render() {
    let errorMessage;
    if (this.props.siteRegister.attempt && this.props.siteRegister.success) {
      this.props.history.push(`/Licenses/${this.props.siteRegister.siteId}`);
    } else if (this.props.siteRegister.attempt && !this.props.siteRegister.success) {
      errorMessage = <div className='row'><Notification variant='error' isBanner={true} open={true} id='errorBanner' primaryText='Error' /><br /><br /></div>;
    }

    const registerButton = (
      <div className='register-actions'>
        {this.props.sitesLoading &&
          <LoadingIndicator variant='radial-progress-bar' size='small' isDeterminate={false} label='Fetching ServIS sites' />}
        <MUIButton variant='primary' size={32} label='Register Site'
          disabled={!this.props.siteSelected || this.props.registeredSiteSelected}
          onClickButton={() => this.props.registerSite()} />
      </div>
    );

    return (
      <div className='container app-content-div'>
        <div>
          <h3>ServIS Sites</h3>
        </div>
        <div className="card-container">
        <div className='row'>
          <div className='col-sm-4 search-container'>
            <Search filter={this.props.searchFilter} applyFilter={this.props.applyFilter} clearFilter={this.props.clearFilter} changeFilterField={this.props.changeFilterField} placeholder={SERVIS_SEARCH_PLACEHOLDER}/>
            {registerButton}
          </div>
        </div>
        {errorMessage}
        <div className='row'>
          <div className='col-md-12'>
            <Sites sites={this.props.sites} sortingSettings={this.props.sortingSettings} history={this.props.history} sortField={this.props.sortField} onCheck={this.props.checkboxSelected} siteSelected={this.props.siteSelected} selectedSite={this.props.selectedSite} searchFilter={this.props.searchFilter} sitesLoading={this.props.sitesLoading} totalNumberOfSites={this.props.totalNumberOfSites} pagingSettings={this.props.pagingSettings} requestPage={this.props.requestPage} requestRowsPerPage={this.props.requestRowsPerPage} />
          </div>
        </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    this.props.requestSitesGet(this.props.pagingSettings, this.props.sortingSettings, this.props.searchFilter, this.props.fromServIs);
  }

  componentWillUnmount() {
    this.props.dispatchLeavingPage();
  }}

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeProps)(RegisterSitesContainer) as any);

export function mapStateToProps(store: { registerState: any; userState: { loggedInUser: { access_token: string } } }) {
  const { access_token: accessToken } = store.userState.loggedInUser;
  return { ...store.registerState, accessToken };
}

function mapDispatchToProps(dispatch: any) {
  return {
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSiteGetRequest(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    registerSite: (selectedSite: ISiteModel, accessToken: string) =>
      dispatch(ActionCreators.onRegisterSite(selectedSite, accessToken)),
    dispatchPagingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onPagingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchSortingChange: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onSortingChange(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken)),
    dispatchApplyFilter: (searchFilter: string, pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, fromServIs: boolean, accessToken: string) =>
      dispatch(ActionCreators.onFilterApplied(searchFilter, pagingSettings, sortingSettings, fromServIs, accessToken)),
    dispatchFilterFieldChange: (searchFilter: string) =>
      dispatch(ActionCreators.onFilterFieldChange(searchFilter)),
    dispatchCheckboxSelected: (siteIsSelected: boolean, selectedSite: ISiteModel) =>
      dispatch(ActionCreators.onSiteSelected(siteIsSelected, selectedSite)),
    dispatchLeavingPage: () =>
      dispatch(ActionCreators.onRegisterPageLeave())
  };
}

function mergeProps({accessToken, ...propsFromState}: any, propsFromDispatch: any, ownProps: any) {
  return {
    ...propsFromState,
    ...ownProps,
    requestSitesGet: (pagingSettings: IPagingSettings, sortingSettings: ISortingSettings, searchFilter: string, fromServIs: boolean) =>
      propsFromDispatch.requestSitesGet(pagingSettings, sortingSettings, searchFilter, fromServIs, accessToken),
    requestPage: (skipItems: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems };
      propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    requestRowsPerPage: (pageSize: number) => {
      const newPagingSettings = { ...propsFromState.pagingSettings, pageSize, skipItems: 0 };
      propsFromDispatch.dispatchPagingChange(newPagingSettings, propsFromState.sortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    sortField: (sortField: string) => {
      let newSortingSettings: { sortField: string; sortDirection: string } | null = null;
      if (sortField === propsFromState.sortingSettings.sortField) {
        const newDirection = propsFromState.sortingSettings.sortDirection === 'asc' ? 'desc' : 'asc';
        newSortingSettings = { ...propsFromState.sortingSettings, sortDirection: newDirection };
      } else {
        newSortingSettings = { sortField, sortDirection: 'asc' };
      }
      propsFromDispatch.dispatchSortingChange(propsFromState.pagingSettings, newSortingSettings, propsFromState.searchFilter, propsFromState.fromServIs, accessToken);
    },
    applyFilter: (event: any) => {
      event.preventDefault();
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems: 0 };
      propsFromDispatch.dispatchApplyFilter(propsFromState.searchFilter, newPagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
    },
    clearFilter: () => {
      const newPagingSettings = { ...propsFromState.pagingSettings, skipItems: 0 };
      return propsFromDispatch.dispatchApplyFilter('', newPagingSettings, propsFromState.sortingSettings, propsFromState.fromServIs, accessToken);
    },
    changeFilterField: (event: React.ChangeEvent<any>) => {
      propsFromDispatch.dispatchFilterFieldChange(event.target.value);
    },
    checkboxSelected: (selectedSite: ISiteModel) => {
      const siteIsSelected = !propsFromState.siteSelected || (propsFromState.selectedSite.servIsId !== selectedSite.servIsId);
      selectedSite = siteIsSelected ? selectedSite : defaultSite;
      propsFromDispatch.dispatchCheckboxSelected(siteIsSelected, selectedSite);
      },
    registerSite: () => propsFromDispatch.registerSite(propsFromState.selectedSite, accessToken),
    dispatchLeavingPage: () => propsFromDispatch.dispatchLeavingPage()
  };
}
